import { Col, Row, Typography } from 'antd';
import { DocumentCard } from 'features/Dashboard/ui/DocumentCard';
import { FolderCard } from 'features/Dashboard/ui/folder-card';
import { Fragment, useState } from 'react';

import { ThirdSubCategory } from './third-sub-category';
const { Title } = Typography;

export const SecondSubCategoryDocumentView = ({
  secondCategoryDocument,
  setCategoryList,
  setShowSubCategory,
  subCategoryName,
  setShowSecondCategory,
  setShowSubSecondCategory,
  setCommentsInfo,
  setAddCommentsModal,
  subCategoryDocument,
}: any) => {
  const [showThirdCategory, setShowThirdCategory] = useState(false);
  const [showSubThirdCategory, setShowSubThirdCategory] = useState(true);
  const [thirdCategoryData, setThirdCategoryData] = useState({});
  const showCategory = () => {
    setCategoryList(true);
    setShowSubCategory(false);
    setShowSecondCategory(false);
    setShowSubSecondCategory(false);
  };

  const showSubCatgoryDocument = () => {
    setCategoryList(false);
    setShowSubCategory(true);
    setShowSecondCategory(false); //
    setShowSubSecondCategory(true);
  };
  const showThirdCategoryData = (data: any) => {
    setShowSubThirdCategory(false);
    setShowThirdCategory(true);
    setThirdCategoryData(data);
  };
  const handleAddComment = (document: any) => {
    setAddCommentsModal(true);
    setCommentsInfo(document);
  };

  return (
    <Fragment>
      <Typography className='ctgrybx'>
        {showSubThirdCategory && (
          <ul>
            <li>
              <a href='javascript:void();' onClick={() => showCategory()}>
                Categories
              </a>
            </li>
            <li>
              <a
                href='javascript:void()'
                onClick={() => showSubCatgoryDocument()}
              >
                {subCategoryName}
              </a>{' '}
            </li>
            <li>{secondCategoryDocument.subCategory}</li>
          </ul>
        )}
      </Typography>
      {showSubThirdCategory && (
        <Row gutter={[16, 16]} justify='start' align='top' className='mb-4'>
          {Array.isArray(secondCategoryDocument.classCategoryList) &&
          secondCategoryDocument.classCategoryList.length
            ? secondCategoryDocument.classCategoryList?.map(
                (item: any, index: number) => {
                  return (
                    <Col
                      key={index}
                      xxl={6}
                      xl={8}
                      lg={8}
                      md={12}
                      sm={24}
                      role='button'
                      className='self-stretch'
                    >
                      {' '}
                      <FolderCard
                        name={item.classCategory}
                        noOfDocuments={item.noOfDocuments}
                        lastUpdatedDate={item.lastUpdatedDate}
                        onClick={() => showThirdCategoryData(item)}
                        isEmpty={item.noOfDocuments === 0}
                      />
                    </Col>
                  );
                },
              )
            : ''}
        </Row>
      )}
      {showSubThirdCategory && (
        <Col span={24}>
          <Title level={4}>Document</Title>
          <Fragment>
            <Row gutter={[16, 16]} justify='start' align='top' className='mb-4'>
              {Array.isArray(secondCategoryDocument.documentList) &&
              secondCategoryDocument.documentList.length
                ? secondCategoryDocument.documentList?.map(
                    (item: any, index: number) => (
                      <Col
                        key={index}
                        xxl={6}
                        xl={8}
                        lg={8}
                        md={12}
                        sm={24}
                        role='button'
                        className='self-stretch'
                      >
                        {' '}
                        {/* Adjust the span as needed */}
                        <DocumentCard
                          document={item}
                          onAddComment={handleAddComment}
                        />
                      </Col>
                    ),
                  )
                : 'dsfdf'}
            </Row>
          </Fragment>
        </Col>
      )}
      {showThirdCategory && (
        <ThirdSubCategory
          thirdCategoryData={thirdCategoryData}
          setCategoryList={setCategoryList}
          setShowSubCategory={setShowSubCategory}
          subCategoryName={subCategoryName}
          setShowSecondCategory={setShowSecondCategory}
          setShowSubSecondCategory={setShowSubSecondCategory}
          setCommentsInfo={setCommentsInfo}
          setAddCommentsModal={setAddCommentsModal}
          subCategoryDocument={subCategoryDocument}
          secondCategoryDocument={secondCategoryDocument}
          setShowSubThirdCategory={setShowSubThirdCategory}
          setShowThirdCategory={setShowThirdCategory}
        />
      )}
      {/* </Row> */}
    </Fragment>
  );
};
